export const PASSWORD_REQUIREMENTS = [
  {
    id: 1,
    value: "Must contain 8 or more characters"
  },
  {
    id: 2,
    value: "Must contain a capital letter"
  },
  {
    id: 3,
    value: "Must contain a number"
  },
  {
    id: 4,
    value: "Must contain a special character"
  }
];
